import React from 'react';
import styles from './mobileApp.module.scss';
import SmartImage from '../smartImage/smartImage';

function MobileAppCard({ appleAppIcon, googlePlayIcon }) {
  return (
    <div className={styles.mobileAppWrapper}>
      <div className={styles.mobileAppContainer}>
        {appleAppIcon && (
          <a href={appleAppIcon?.link}>
            <SmartImage
              src={appleAppIcon?.imageurl}
              height={40}
              width={120}
              alt={appleAppIcon?.alt}
            />
          </a>
        )}
        {googlePlayIcon && (
          <a href={googlePlayIcon?.link}>
            <SmartImage
              src={googlePlayIcon?.imageurl}
              height={40}
              width={120}
              alt={googlePlayIcon?.alt}
            />
          </a>
        )}
      </div>
    </div>
  );
}

export default MobileAppCard;
